import {
  Slider,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { expectedLayers } from "../../../../settings/settings";
import { updateLayersMenuState, updateOpenLayer } from "../../../../redux/reducers/menuSlice";
import { Fragment } from "react";
import  granular from "./granular.png"
import nature from "./nature.png"
import walk from "./walk.png"

function VisMenu() {
  const dispatch = useDispatch();
  const cityIOdata = useSelector((state) => state.cityIOdataState.cityIOdata);
  const layersMenuReduxState = useSelector(
    (state) => state.menuState.layersMenuState
  );
  const [layer, setLayer] = useState('');
  const handleChange = (event) => {
    
    const newLayersMenuState = { ...layersMenuState };
    for (let i = 0; i < cityIOdata.layers.length; i++) {
        if(cityIOdata.layers[i].properties.context === true){
          continue;
        }
        const moduleName = cityIOdata.layers[i].id;
        newLayersMenuState[moduleName] = {
            isOn: false,
            slider: newLayersMenuState[moduleName] ? newLayersMenuState[moduleName].slider : 50,
        };
    }

    setLayersMenuState({...newLayersMenuState, [event.target.value]: {
            isOn: true,
            slider: newLayersMenuState[event.target.value] ? newLayersMenuState[event.target.value].slider : 50,
          }})

    setLayer(event.target.value);

    dispatch(updateOpenLayer(event.target.value));
  };


  // update the layer slider value
  const [sliderVal, setSliderVal] = useState(() => {
    const sv = {};
    for (const menuItem in expectedLayers) {
      sv[menuItem] = expectedLayers[menuItem].initSliderValue;
    }
    return sv;
  });

  // initial layer menu state
  const [layersMenuState, setLayersMenuState] = useState({});

  useEffect(() => {

    const combinedLayersMenuState = { ...layersMenuReduxState, ...layersMenuState };
    if(Object.keys(combinedLayersMenuState).length > 0)
      dispatch(updateLayersMenuState(combinedLayersMenuState));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layersMenuState]);

  const updateSliderVal = (menuItem, val) => {
    setSliderVal({ ...sliderVal, [menuItem]: val });
  };

  const commitSliderVal = (menuItem, val) => {
    setLayersMenuState({
      ...layersMenuState,
      [menuItem]: {
        ...layersMenuState[menuItem],
        slider: val,
      },
    });
  };

  const toggleListArr = [];

  const makeLayerControlsMenu = () => {

    toggleListArr.push(
      <Fragment key={"fragment_"}>
      <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Layer</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={layer}
        label="Layer"
        onChange={handleChange}
      >
        <MenuItem key="menu_None" value="">
            <em>None</em>
        </MenuItem>
        {cityIOdata.layers.filter((layer)=>(layer.properties.context === false)).map((layer) => (
        <MenuItem key={"menu_"+layer.id} value={layer.id}>
          {layer.id}
        </MenuItem>
        ))}
      </Select>
      </FormControl>
    </Fragment>)
    // loop through the keys in deckgl layers
    if(cityIOdata.layers)
      for (let i = 0; i < cityIOdata.layers.length; i++) {
        if(cityIOdata.layers[i].properties.context === true){
          continue;
        }
        const moduleName = cityIOdata.layers[i].id;
        // if the module name is in the data for this CS instance, make a checkbox
        if (layer === moduleName) {
          toggleListArr.push(
            <Fragment key={"fragment_" + moduleName}>

              {layersMenuState[moduleName] && layersMenuState[moduleName].isOn && (
          <Slider
            size="small"
            key={"slider_" + moduleName}
            valueLabelDisplay="auto"
            onChangeCommitted={(_, val) => commitSliderVal(moduleName, val)}
            onChange={(_, val) => updateSliderVal(moduleName, val)}
            value={sliderVal[moduleName] ?? 50}
            min={1}
          />
              )}
            <Typography variant="caption" key={"drescrip_" + moduleName} sx={{justifyContent: 'flex-start', margin: 'auto', fontSize: '12px'}}>

              {cityIOdata.layers[i].properties.description  || "No description available"}
            </Typography>
            <Divider sx={{margin: '2px'}}></Divider>

            {moduleName.includes('Granu') && layersMenuState[moduleName] && layersMenuState[moduleName].isOn && (
              
              <>              <Typography variant="body2" color="textSecondary" key={"info_" + moduleName} >
              Granular building legend. Gray implies less granular building fabric.
            </Typography>
            <img
                  src={granular}
                  alt={'Granular building legend'}
                  width={175} height={35}
                  loading="lazy"
                />
              </>
              )}

              {moduleName.includes('Walk') && layersMenuState[moduleName] && layersMenuState[moduleName].isOn && (
              
              <>              <Typography variant="body2" color="textSecondary" key={"info_" + moduleName}>
              Walkability legend. Gray implies less walkability.
            </Typography>
            <img
                  src={walk}
                  alt={'Walkability legend'}
                  width={175} height={35}
                  loading="lazy"
                />
              </>
              )}
              {moduleName.includes('Nature') && layersMenuState[moduleName] && layersMenuState[moduleName].isOn && (
              
              <>              <Typography variant="body2" color="textSecondary" key={"info_" + moduleName}>
              Access to nature legend. Gray implies less access to nature.
            </Typography>
            <img
                  src={nature}
                  alt={'Access to nature lagend'}
                  width={175} height={35}
                  loading="lazy"
                />
              </>
              )}

              </Fragment>
          );
        }
        
      }
    
    return toggleListArr;
  };

  return makeLayerControlsMenu();
}

export default VisMenu;
